//add a default image to images that 404 (movie posters)
//function missingImageError() {
//  this.onerror = null;
//  this.parentNode.children[0].srcset = this.parentNode.children[1].srcset = this.src;
//}

//attempt reload homepage cover images, if they fail show a default image
  function missingImageError(image) {
    if (!image.hasOwnProperty('retryCount')){
      image.retryCount = 0;
    }

    if (image.retryCount < 10) {
      setTimeout(function (){  
          image.src += '&' +  Date.now();   
          image.retryCount += 1;
      }, 2000);
    } else {
        //after x number of attemps show the missing poster file
        image.onerror = null;
        image.parentNode.children[0].srcset = image.parentNode.children[1].srcset = "/Assets/Celebration/Icons/MissingPoster.jpg";
        image.style.visibility = 'visible';
    }
  }

//once a failed image reloads, make sure its set visibile
function missingImageLoaded(image) {
    image.style.visibility = 'visible';
    setTimeout(function() { image.style.visibility = 'visible'; }, 1000);
}